import { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import EditModal from "./EditModal";
import RemoveModal from "./RemoveModal";
import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function AcademicYears() {
  const snapshot = useSelector(state => state.snapshot.fileName);
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(null);
  const [removeModal, setRemoveModal] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      const response = await api.getAcademicYears();
      response.sort((a, b) => b.year.localeCompare(a.year));
      setYears(response);
    } catch (error) {
      toastService.send({ title: "Fout", message: `${error}` });
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = year => {
    setEditModal(
      <EditModal data={year} hideModal={() => { setEditModal(null); load(); }} />
    );
  };

  const openRemoveModal = year => {
    setRemoveModal(
      <RemoveModal data={year} hideModal={() => { setRemoveModal(null); load(); }} />
    );
  };

  const gridStyle = { minHeight: 550 };

  const columns = [
    { name: 'year', header: 'Academiejaar', defaultFlex: 1 },
    {
      name: 'current_year', header: 'Huidig', defaultFlex: 0, minWidth: 100, draggable: false, sortable: false,
      render: ({ data }) => data.current_year
        ? <i className="far fa-check" />
        : null
    },
    {
      name: 'id', header: 'Acties', defaultFlex: 1, draggable: false, sortable: false,
      render: ({ data }) => (
        <div>
          <Button
            variant="info"
            onClick={() => openEditModal(data)}
            disabled={snapshot}
            title="Bewerken"
          >
            <i className="far fa-edit" />
          </Button>{" "}
          <Button
            variant="danger"
            onClick={() => openRemoveModal(data)}
            disabled={snapshot || data.current_year}
            title="Verwijderen"
          >
            <i className="far fa-trash" />
          </Button>
        </div>
      )
    }
  ];

  const filterValue = [
    { name: 'year', operator: 'contains', type: 'string', value: '' }
  ];

  useEffect(() => { load(); }, []);

  if (loading) {
    return (
      <div className="text-center">
        <i className="fad fa-spinner-third fa-spin fa-5x" />
      </div>
    );
  }

  return (
    <Container>
      {editModal}
      {removeModal}
      <Row>
        <h1>Academiejaren</h1>
      </Row>
      <Row className="my-2">
        <Col className="text-end">
          <Button variant="success" onClick={() => openEditModal()} disabled={snapshot}>
            <i className="far fa-plus" />&nbsp;Nieuw
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <ReactDataGrid
            idProperty="id"
            style={gridStyle}
            defaultFilterValue={filterValue}
            columns={columns}
            dataSource={years}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default AcademicYears;
